import React, { createContext, useState } from 'react';
import translations from '../translations'; // Import translations

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(localStorage.getItem('language') || 'EN'); // Load language from localStorage

    const handleLanguageChange = (lang) => {
        setLanguage(lang);
        localStorage.setItem('language', lang); // Save language to localStorage
    };

    const t = translations[language]; // Get translations for the selected language

    return (
        <LanguageContext.Provider value={{ language, t, handleLanguageChange }}>
            {children}
        </LanguageContext.Provider>
    );
};